import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CLOSE: "Lukk",
      CONTENTS: "Innhold",
      NETTOWEIGHT: "Nettovekt",
      INGREDIENTS: "Ingredienser",
      ALLERGIES: "Allergener",
      SUPPLIER: "Leverandør",
      NUTRITION_FACTS: "Næringsinnhold per 100 g",

      OFFERS: "Tilbud",
      ADD: "Legg til",
      stockState: {
        "limited-stock": "Begrenset antall",
        "maximum-amount-added": "Maks antall valgt",
        "sold-out": "Utsolgt",
      },
      THERE_WAS_AN_ERROR_FETCHING_PRODUCT:
        "Det oppstod en feil ved henting av produktet. Vennligst prøv igjen senere.",
      THE_INFORMATION_ABOUT_THIS_PRODUCT_COULD_BE_OUT_OF_DATE:
        "Informasjonen om dette produktet kan være utdatert, siden det ikke lenger finnes i vårt sortiment.",
    },

    dk: {
      CLOSE: "Luk",
      CONTENTS: "Indhold",
      NETTOWEIGHT: "Størrelse",
      INGREDIENTS: "Ingredienser",
      ALLERGIES: "Allergener",
      SUPPLIER: "Leverandør",
      NUTRITION_FACTS: "Næringsindhold per 100 g",

      OFFERS: "Tilbud",
      ADD: "Tilføj",
      stockState: {
        "limited-stock": "Begrænset antal",
        "maximum-amount-added": "Max antal valgt",
        "sold-out": "Udsolgt",
      },
      THERE_WAS_AN_ERROR_FETCHING_PRODUCT:
        "Der opstod en fejl ved hentning af produktet. Prøv venligst igen senere.",
      THE_INFORMATION_ABOUT_THIS_PRODUCT_COULD_BE_OUT_OF_DATE:
        "Informationen om dette produkt kan være forældet, da det ikke længere findes i vores sortiment.",
    },

    se: {
      CLOSE: "Stäng",
      CONTENTS: "Innehållsförteckning",
      NETTOWEIGHT: "Mängd/vikt",
      INGREDIENTS: "Ingredienser",
      ALLERGIES: "Allergener",
      SUPPLIER: "Leverantör",
      NUTRITION_FACTS: "Näringsvärde, per 100 gram",

      OFFERS: "Kampanj",
      ADD: "Lägg till",
      stockState: {
        "limited-stock": "Begränsat antal kvar",
        "maximum-amount-added": "Max antal valda",
        "sold-out": "Slutsåld",
      },
      THERE_WAS_AN_ERROR_FETCHING_PRODUCT:
        "Ett fel uppstod vid hämtning av produkten. Försök igen senare.",
      THE_INFORMATION_ABOUT_THIS_PRODUCT_COULD_BE_OUT_OF_DATE:
        "Informationen om denna produkt kan vara föråldrad, eftersom den inte längre finns i vårt sortiment.",
    },
  } as const
)[language];
